// extracted by mini-css-extract-plugin
export default {"view":"ChangesEntity_view__UaiVr"};